const Common = (app) => {
  app
    .post("/common/refresh", async ({ res }) => {
      res.backDontScroll();
    })
    .post("/common/toast", async ({ req, res, flash }) => {
      const { body } = req;
      const { type, message } = body;
      flash(type, message);
      res.backDontScroll();
    });
};

export default Common;
